import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export function Link({ underline = 'always', className, children, ...others }) {
    let underlineClass;
    if (underline === 'always') {
        underlineClass = 'underline';
    }
    else if (underline === 'hover') {
        underlineClass = 'hover:underline';
    }
    return _jsx("a", { className: clsx("text-indigo-800 dark:text-indigo-300", className, underlineClass), ...others, children: children });
}
//# sourceMappingURL=Link.js.map